
import {finalize} from 'rxjs/operators';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Dossier } from '../dossier/dossier';
import { DossierModel } from '../dossier-model/dossier-model';
import { NotifierService } from '../ui';
import { DossierService } from '../dossier/dossier.service';
import { DataLink } from '../data-link/data-link';
import { map } from 'lodash';

const DATA_LINK_NAME = 'donnees_financieres';
const NAME_FIELD = 'exercice_comptable';


export interface YearRange {
  link_1_id: string,
  link_2_id: string,
  label: string
}


@Component({
  selector: 't-financial-data-report',
  templateUrl: './financial-data-report.component.html',
})
export class FinancialDataReportComponent implements OnInit {

  ranges: YearRange[];

  selectedRange: YearRange;

  @Output()
  selectedRangeChanged = new EventEmitter<YearRange>();
  
  @Input()
  dossier: Dossier
  
  @Input()
  dossierModel: DossierModel

  constructor(
    private notifier: NotifierService,
    private dossierService: DossierService
  ){}

  ngOnInit(): void {
    this.notifier.updateProgress(50);

    // Get data links
    this.dossierService.linksByName(this.dossier.id, DATA_LINK_NAME).pipe(
    finalize(() => {
      this.notifier.endProgress();
    }))
    .subscribe((links) => {
      this.ranges = [];

      let dataLinks = map(links, l => l as DataLink);

      // Sort last year first
      dataLinks.sort((a, b) => {
        let nameA = a.lookupFieldValue(NAME_FIELD);
        let nameB = b.lookupFieldValue(NAME_FIELD);

        if(nameA === nameB) {
          return 0;
        }
        else if(nameA > nameB) {
          return -1;
        }
        else {
          return 1;
        }
      })

      // Create ranges
      for (let i = 0; i < dataLinks.length - 1; i++) {
        let link_1 = dataLinks[i + 1];
        let link_2 = dataLinks[i];
        let name_1 = link_1.lookupFieldValue(NAME_FIELD);
        let name_2 = link_2.lookupFieldValue(NAME_FIELD);
        
        this.ranges.push({
          link_1_id: link_1.id,
          link_2_id: link_2.id,
          label: `${name_1} - ${name_2 }`
        });
      }

      // Add a year range for the first year data link
      if(dataLinks.length > 0) {
        const lastDataLink = dataLinks[dataLinks.length - 1];

        let name_2 = lastDataLink.lookupFieldValue(NAME_FIELD);

        let name_2_number = parseInt(name_2, 10);
        let name_1 = '';

        if(!isNaN(name_2_number)) {
          name_1 = (name_2_number - 1).toString();
        }

        this.ranges.push({
          link_1_id: 'empty',
          link_2_id: lastDataLink.id,
          label: `${name_1} - ${name_2}`
        });
      }

      // Select the first range
      if (this.ranges.length > 0) {
        this.onSelect(this.ranges[0]);
      }
    });
  }

  onSelect(range: YearRange) {
    this.selectedRange = range;
    this.selectedRangeChanged.emit(range);
  }
}